/**
 * DSGVO/UWG E-Mail Compliance Rules
 * Basiert auf aktuellen Urteilen (2022-2025)
 */

export const ComplianceRules = {
  // 🔴 ROT = Hohe Abmahngefahr / fast immer Werbung
  RED_TRIGGERS: [
    // Lockangebote / Gratis-Phrasen
    {
      pattern: /\b(?:kostenlos(?:es|en|er|em)?|kostenfrei(?:es|en|er|em)?|gratis|umsonst|ohne\s+kosten|zum\s+nulltarif|for\s+free|unentgeltlich(?:es|en|er|em)?|gebührenfrei(?:es|en|er|em)?|kostenneutral(?:es|en|er|em)?|ohne\s+gebühr(?:en)?|gegen\s+0\s+euro|für\s+0\s*€)\s+(?:erstgespräch|audit|coaching|analysegespräch|strategiegespräch|diagnostik|call|session|beratung|workshop|webinar|training|kompass[-\s]?call|kennenlern[-\s]?gespräch)/gi,
      reason: 'Lockangebot - BGH I ZR 78/20',
      severity: 'high',
      label: 'Kostenloses/Gratisangebot für Dienstleistung'
    },
    {
      pattern: /\b(?:kostenlos|kostenfrei|gratis)(?:es|e|er|em)?\s+(?:1:1|1-zu-1|einzelgespräch)\s+(?:session|gespräch|call)\s*\([^\)]*(?:\d+[-–]\d+|ca\.\s*\d+)\s*min/gi,
      reason: 'Lockangebot mit Zeitangabe - BGH I ZR 78/20',
      severity: 'high',
      label: 'Kostenloses 1:1 Gespräch mit Zeitangabe'
    },
    {
      pattern: /\b(?:als|zum|ein)\s+geschenk\b/gi,
      reason: 'Lockangebot - BGH I ZR 78/20',
      severity: 'high',
      label: 'Als Geschenk (Lockangebot)'
    },
    {
      pattern: /\b(?:schenke|schenk)\s+(?:ich\s+)?(?:dir|ihnen|euch)\b/gi,
      reason: 'Lockangebot durch Schenken - BGH I ZR 78/20',
      severity: 'high',
      label: 'Schenke dir/Ihnen'
    },
    {
      pattern: /\bgeschenkt\s+bekommen\b/gi,
      reason: 'Lockangebot - BGH I ZR 78/20',
      severity: 'high',
      label: 'Geschenkt bekommen'
    },
    {
      pattern: /\bvergebe\s+(?:kostenfrei|kostenlos|gratis)/gi,
      reason: 'Verknappung + Lockangebot - LG Berlin 52 O 128/23',
      severity: 'high',
      label: 'Vergebe kostenlos/kostenfrei'
    },
    {
      pattern: /\b(?:verschenke|vergebe|verlose|biete|öffne|gebe)\s+(?:im\s+\w+\s+)?(?:\d+|einige|wenige)\s+(?:kostenlose[nr]?|gratis)?\s*(?:sessions?|plätze?|termine?|calls?|spots?|tickets?)\b/gi,
      reason: 'Verknappung + Lockangebot - LG Berlin 52 O 128/23',
      severity: 'high',
      label: 'Verschenke/Vergebe X Sessions/Plätze'
    },
    {
      pattern: /\b(?:ich|wir)\s+(?:vergebe|biete|öffne|gebe|habe\s+noch)\s+(?:nur\s+noch\s+)?\d+\s+(?:kostenlose[nr]?|gratis|freie)?\s*(?:plätze?|termine?|spots?|sessions?)?\b/gi,
      reason: 'Zahlenbegrenzung = Verknappung - LG Berlin 52 O 128/23',
      severity: 'high',
      label: 'Ich vergebe/biete X Plätze (Verknappung)'
    },
    {
      pattern: /\bbevor\s+(?:dieses?|das)\s+(?:neue\s+)?(?:angebot|programm|produkt)\s+(?:offiziell\s+)?(?:startet|live\s+geht|verfügbar\s+wird)/gi,
      reason: 'Exklusivität + Zeitdruck = Verknappung - LG Berlin 52 O 128/23',
      severity: 'high',
      label: 'Bevor Angebot startet (Exklusivität)'
    },
    {
      pattern: /\b(?:bis|nur\s+noch\s+bis)\s+(?:jahresende|ende|dezember|\d{1,2}\.\d{1,2})/gi,
      reason: 'Zeitliche Verknappung - LG Berlin 52 O 128/23',
      severity: 'high',
      label: 'Zeitliche Begrenzung (bis Jahresende/Datum)'
    },
    {
      pattern: /\b(?:nur\s+noch\s+bis|vergebe\s+(?:die\s+)?(?:kostenlosen\s+)?plätze\s+nur\s+(?:noch\s+)?bis)\s+ende\s+(?:des\s+)?(?:jahres|monats)/gi,
      reason: 'Zeitliche Verknappung mit Lockangebot - LG Berlin 52 O 128/23',
      severity: 'high',
      label: 'Vergebe Plätze nur noch bis Ende...'
    },
    {
      pattern: /\bdanach\s+(?:schließe\s+ich|schließt)\s+(?:dieses\s+)?(?:feld|angebot|programm)\s+wieder\b/gi,
      reason: 'Künstliche Verknappung durch Schließung - LG Berlin 52 O 128/23',
      severity: 'high',
      label: 'Danach schließe ich dieses Feld'
    },
    {
      pattern: /\b(?:diese\s+)?phase\s+(?:ist\s+)?(?:energetisch\s+)?(?:so\s+)?(?:klar\s+)?begrenzt\b/gi,
      reason: 'Esoterische Verknappung = Verkaufsdruck',
      severity: 'high',
      label: 'Phase ist (energetisch) begrenzt'
    },
    {
      pattern: /\ban\s+ausgewählte\s+(?:frauen|männer|personen|kunden)/gi,
      reason: 'Exklusivität = Verknappung',
      severity: 'high',
      label: 'An ausgewählte Personen (Exklusivität)'
    },
    
    // Wertangaben - ALLGEMEIN: Beliebige Beträge & Währungen
    {
      pattern: /\bwert[:=\s]+(?:von\s+)?\d+(?:[.,]\d+)?\s*(?:[€$£¥₹]|euro|dollar|chf|usd|eur)\b/gi,
      reason: 'Wertangabe = Verkaufsabsicht - OLG Köln 6 U 68/22',
      severity: 'high',
      label: 'Wertangabe (Wert: X €)'
    },
    {
      pattern: /\b(?:im|von)\s+wert\s+(?:von\s+)?\d+(?:[.,]\d+)?\s*(?:[€$£¥₹]|euro|dollar|chf|usd|eur)?\b/gi,
      reason: 'Wertangabe = Verkaufsabsicht - OLG Köln 6 U 68/22',
      severity: 'high',
      label: 'Im Wert von X'
    },
    {
      pattern: /\b(?:normalerweise|gewöhnlich|üblicherweise|regulär)\s+\d+(?:[.,]\d+)?\s*[€$£¥₹]\b/gi,
      reason: 'Preisvergleich = Werbung',
      severity: 'high',
      label: 'Normalpreis-Angabe'
    },
    {
      pattern: /\b(?:statt|ursprünglich|sonst|ansonsten)\s+\d+(?:[.,]\d+)?\s*[€$£¥₹]\b/gi,
      reason: 'Preisvergleich = Werbung',
      severity: 'high',
      label: 'Preisvergleich (Statt/Ursprünglich)'
    },
    
    // Verknappung / Scarcity - ALLGEMEIN
    {
      pattern: /\b(?:nur\s+noch|letzten?|verbleibende)\s+(?:\d+|wenige|einzelne)\s+(?:plätze?|termine?|spots?|sessions?|calls?|tickets?)\s+(?:frei|verfügbar|offen|übrig)\b/gi,
      reason: 'Verknappung - LG Berlin 52 O 128/23',
      severity: 'high',
      label: 'Nur noch X Plätze/Termine (Verknappung)'
    },
    {
      pattern: /\b(?:limitierte?[rs]?|begrenzte?[rs]?|beschränkte?[rs]?|exklusive[rs]?)\s+(?:plätze?|teilnehmerzahl|termine?|anzahl|kapazität|kontingent)\b/gi,
      reason: 'Verknappung - LG Berlin 52 O 128/23',
      severity: 'high',
      label: 'Limitierte Plätze/Anzahl'
    },
    {
      pattern: /\b(?:letzte|finale)\s+(?:chance|möglichkeit|gelegenheit)\b/gi,
      reason: 'Zeitdruck durch Verknappung - LG Berlin 52 O 128/23',
      severity: 'high',
      label: 'Letzte Chance'
    },
    {
      pattern: /\bjetzt\s+oder\s+nie\b/gi,
      reason: 'Extremer Zeitdruck - LG Berlin 52 O 128/23',
      severity: 'high',
      label: 'Jetzt oder nie'
    },
    {
      pattern: /\b(?:fast|nahezu|beinahe)\s+(?:ausgebucht|voll|ausverkauft)\b/gi,
      reason: 'Künstliche Verknappung - LG Berlin 52 O 128/23',
      severity: 'high',
      label: 'Fast ausgebucht'
    },
    {
      pattern: /\bsolange\s+(?:der\s+)?vorrat\s+reicht\b/gi,
      reason: 'Verknappung - LG Berlin 52 O 128/23',
      severity: 'high',
      label: 'Solange Vorrat reicht'
    },
    {
      pattern: /\b(?:die|nur|noch)?\s*(?:letzten?|verbleibenden?)\s+(?:\d+|wenige|einzelne)\s+(?:plätze?|termine?|spots?|sessions?|calls?|tickets?)\b/gi,
      reason: 'Verknappung mit Endlichkeit - LG Berlin 52 O 128/23',
      severity: 'high',
      label: 'Die letzten/verbleibenden X Plätze'
    },
    
    // Call-to-Action - ALLGEMEIN
    {
      pattern: /\b(?:jetzt|heute|sofort|gleich)\s+(?:buchen|anmelden|sichern|kaufen|registrieren|bestellen|zugreifen|starten|loslegen|einsteigen|dabei\s+sein)\b/gi,
      reason: 'Direkter Call to Action - OLG Hamburg 5 U 92/22',
      severity: 'high',
      label: 'Jetzt buchen/anmelden/sichern'
    },
    {
      pattern: /\b(?:klick|klicke|klicken\s+sie|drücken\s+sie|tippen\s+sie)\s+(?:hier|jetzt|auf\s+den\s+link|den\s+button|unten|oben)\b/gi,
      reason: 'Direkter Link-Call-to-Action - OLG Hamburg 5 U 92/22',
      severity: 'high',
      label: 'Klick hier/jetzt'
    },
    {
      pattern: /\b(?:melde|melden\s+sie|meld)\s+(?:dich|sich)\s+(?:jetzt|heute|sofort|gleich|schnell)?\s*(?:an|ab|ein)\b/gi,
      reason: 'Anmelde-Aufforderung - OLG Hamburg 5 U 92/22',
      severity: 'high',
      label: 'Melde dich jetzt an'
    },
    {
      pattern: /\b(?:verpasse|verpassen\s+sie)\s+(?:nicht|keine|kein)\b/gi,
      reason: 'FOMO-Taktik (Fear of Missing Out) - Verkaufsdruck',
      severity: 'high',
      label: 'Verpasse nicht (FOMO)'
    },
    {
      pattern: /\b(?:handel|handeln\s+sie)\s+(?:jetzt|sofort|heute)\b/gi,
      reason: 'Dringlichkeitsaufforderung - Verkaufsdruck',
      severity: 'high',
      label: 'Handel jetzt'
    },
    {
      pattern: /\bbevor\s+es\s+zu\s+spät\s+ist\b/gi,
      reason: 'Extremer Zeitdruck - FOMO-Taktik',
      severity: 'high',
      label: 'Bevor es zu spät ist'
    },
    {
      pattern: /(?:termin|platz)\s+(?:jetzt\s+)?buchen/gi,
      reason: 'Abschlussaufforderung - LG Düsseldorf 38 O 45/23',
      severity: 'high',
      label: 'Termin buchen'
    },
    {
      pattern: /sicher(?:n|t)\s+sie\s+(?:sich|ihren)/gi,
      reason: 'Verkaufsaufforderung',
      severity: 'high',
      label: 'Sichern Sie sich'
    },
    
    // Garantien und Versprechen - ALLGEMEIN
    {
      pattern: /\b(?:geld[-\s]?zurück|100%|zufriedenheits|erfolgs|ergebnis)[-\s]?garantie\b/gi,
      reason: 'Verkaufsgarantie = klare Werbung - § 5 UWG',
      severity: 'high',
      label: 'Garantie (Geld-zurück/Erfolgs/Zufriedenheits)'
    },
    {
      pattern: /\b(?:garantiert|garantieren|versprechen?|zusichern)\s+(?:erfolgreich|erfolg|ergebnis(?:se)?|resultate?|mehr\s+umsatz|wachstum)\b/gi,
      reason: 'Erfolgsgarantie = unzulässiges Versprechen - § 5 UWG',
      severity: 'high',
      label: 'Garantierter Erfolg/Ergebnis'
    },
    {
      pattern: /\b(?:100%|vollständig|komplett|absolut)\s+(?:sicher|garantiert|kostenlos|gratis|risikolos|risikofrei)\b/gi,
      reason: 'Absolute Versprechen = Verkaufssprache',
      severity: 'high',
      label: '100%/Absolut sicher/garantiert'
    },
    
    // 🚨 HEILVERSPRECHEN & PSEUDOWISSENSCHAFT - EXTREM KRITISCH!
    {
      pattern: /\b(?:heilung|heilen|heilt|geheilt)\b(?!\s+(?:von\s+)?(?:seelen|herzen))/gi,
      reason: '⚠️ HEILVERSPRECHEN - nur für Ärzte/Heilpraktiker erlaubt! § 1 HeilMG + § 5 UWG',
      severity: 'high',
      label: '🚨 HEILVERSPRECHEN (illegal!)'
    },
    {
      pattern: /\b(?:geld|erfolg|money)[-\s]?(?:fluss|flow|frequenz|energie)\b/gi,
      reason: 'Pseudowissenschaftliche Erfolgsversprechen - § 5 UWG irreführend',
      severity: 'high',
      label: 'Geldfluss/Money Frequency (pseudowissenschaftlich)'
    },
    {
      pattern: /\benerg(?:etisch(?:e[snr]?)?|ie)[-\s]?(?:feld|analyse|diagnose|diagnostic|arbeit|system)\b/gi,
      reason: 'Pseudowissenschaftliche Methoden ohne wissenschaftliche Basis - § 5 UWG',
      severity: 'high',
      label: 'Energetisches Feld/Analyse (pseudowissenschaftlich)'
    },
    {
      pattern: /\bwelche\s+(?:frequenz|schwingung|energie)\s+(?:du|sie)\s+aktivieren\s+(?:darfst|kannst|solltest)\b/gi,
      reason: 'Pseudowissenschaftliche Versprechen - Missbrauch physikalischer Begriffe',
      severity: 'high',
      label: 'Frequenz aktivieren (pseudowissenschaftlich)'
    },
    {
      pattern: /\b(?:geld|erfolg)[-\s]?(?:blockaden?|blockierungen?)\s+(?:lösen|auflösen|erkennen|beseitigen)\b/gi,
      reason: 'Pseudotherapeutische Erfolgsversprechen - § 5 UWG',
      severity: 'high',
      label: 'Geldblockaden lösen'
    },
    {
      pattern: /\bunbewusste\s+(?:programme|muster|blockaden)\s+(?:die\s+)?(?:dich\s+)?(?:leiten|bremsen|blockieren)\b/gi,
      reason: 'Pseudo-psychologische Versprechen ohne Qualifikation',
      severity: 'high',
      label: 'Unbewusste Programme (pseudo-psychologisch)'
    },
    {
      pattern: /\b(?:krankheit(?:en)?|beschwerden?|symptome?)\s+(?:behandeln|lindern|beseitigen|heilen)/gi,
      reason: '⚠️ Medizinische Behandlungsversprechen ohne Zulassung - § 1 HeilMG',
      severity: 'high',
      label: 'Krankheiten behandeln/heilen'
    },
    {
      pattern: /\b(?:schmerzen?|blockaden?)\s+(?:lösen|auflösen|beseitigen|entfernen)\b/gi,
      reason: 'Medizinische/therapeutische Versprechen - § 1 HeilMG',
      severity: 'high',
      label: 'Schmerzen/Blockaden lösen'
    },
    {
      pattern: /\b(?:der|die|das)\s+heilung\s+verschrieben\b/gi,
      reason: '⚠️ Heilversprechen - nur für zugelassene Heilberufe! § 1 HeilMG',
      severity: 'high',
      label: 'Der Heilung verschrieben'
    },
    
    // Pseudowissenschaft / Quanten-Esoterik
    {
      pattern: /\bquanten[-\s]?(?:heilung|aufrichtung|energie|feld|medizin|therapie)/gi,
      reason: 'Pseudowissenschaft - Missbrauch des Begriffs "Quanten" - § 5 UWG irreführend',
      severity: 'high',
      label: 'Quanten- (pseudowissenschaftlich)'
    },
    {
      pattern: /\b(?:wissenschaftlich|klinisch)\s+(?:bewiesen|erwiesen|belegt|nachgewiesen)\b/gi,
      reason: 'Falsche wissenschaftliche Behauptungen - § 5 UWG irreführende Werbung',
      severity: 'high',
      label: 'Wissenschaftlich bewiesen (Falschbehauptung)'
    },
    {
      pattern: /\bbeweise\s+ich\s+(?:täglich|live|regelmäßig)\b/gi,
      reason: 'Suggeriert wissenschaftliche Beweise für fragwürdige Methoden',
      severity: 'high',
      label: 'Beweise ich täglich'
    },
    
    // Erfolgsversprechen (Umsatz/Geld/Einsparungen) - ALLGEMEIN
    {
      pattern: /\b(?:4|5|6|7|8)[-\s]?stellig(?:e[snr]?|er|en)?\s+(?:umsatz|umsätze|jahresumsatz|einnahmen|verdienst|einkommen|gewinn|monatsumsatz)\b/gi,
      reason: 'Erfolgsversprechen Umsatz - § 5 UWG irreführende Werbung',
      severity: 'high',
      label: 'X-stellige Umsätze/Einnahmen erreichen'
    },
    {
      pattern: /\bmehr\s+aus\s+(?:dem\s+bestehenden|ihrer|deiner|eurer)\s+(?:umsatz|struktur)\s+(?:heraus)?hol(?:en|t)\b/gi,
      reason: 'Erfolgsversprechen - mehr Umsatz/Profit - § 5 UWG',
      severity: 'high',
      label: 'Mehr aus Umsatz/Struktur herausholen'
    },
    {
      pattern: /\bohn(?:e|em?)\s+mehr\s+(?:umsatz|arbeit|aufwand)\s+(?:machen\s+zu\s+müssen|zu\s+machen)\b/gi,
      reason: 'Unrealistisches Erfolgsversprechen - § 5 UWG',
      severity: 'high',
      label: 'Ohne mehr Umsatz machen zu müssen'
    },
    {
      pattern: /\bgünstigere\s+(?:laufende\s+)?kosten\b/gi,
      reason: 'Kostenersparnis-Versprechen = Verkaufsabsicht',
      severity: 'high',
      label: 'Günstigere Kosten'
    },
    {
      pattern: /\b(?:einkommens|umsatz)[-\s]?(?:sprung|boost|explosion|durchbruch)\b/gi,
      reason: 'Erfolgsversprechen Einkommen - § 5 UWG',
      severity: 'high',
      label: 'Einkommenssprung/Umsatzsprung'
    },
    {
      pattern: /\b(?:geld|umsatz|einkommen)\s+(?:leichter|einfach(?:er)?|mühelos)\s+(?:zu\s+dir\s+)?(?:fließ(?:en|t)|komm(?:en|t)|verdienen)/gi,
      reason: 'Erfolgsversprechen Geld - § 5 UWG',
      severity: 'high',
      label: 'Geld leichter fließen/verdienen'
    },
    {
      pattern: /\b(?:finanzielle|monetäre|geldliche)\s+(?:freiheit|unabhängigkeit|transformation)/gi,
      reason: 'Erfolgsversprechen - § 5 UWG',
      severity: 'high',
      label: 'Finanzielle Freiheit versprechen'
    },
    {
      pattern: /\b(?:dein|ihr)\s+nächst(?:er|en)\s+(?:einkommens|umsatz|finanz)[-\s]?(?:level|sprung|schritt)\b/gi,
      reason: 'Erfolgsversprechen - § 5 UWG',
      severity: 'high',
      label: 'Nächster Einkommenssprung'
    },
    {
      pattern: /\b(?:verdopple|verdreifache|vervielfache|steigere|maximiere|erhöhe|optimiere|booste|skaliere)\s+(?:dein(?:en)?|ihr(?:en)?|euer(?:en)?)\s+(?:umsatz|umsätze|einkommen|einnahmen|gewinn|gewinne|erfolg|verdienst|revenue)\b/gi,
      reason: 'Erfolgsversprechen mit Steigerung - § 5 UWG',
      severity: 'high',
      label: 'Verdopple/Steigere deinen Umsatz'
    },
    {
      pattern: /\b(?:von|aus)\s+(?:0|null)\s+auf\s+(?:\d+|4|5|6|7|8)[-\s]?stellig(?:e[snr]?)?\s*(?:umsatz|einkommen|gewinn|erfolg)?\b/gi,
      reason: 'Erfolgsversprechen - § 5 UWG',
      severity: 'high',
      label: 'Von 0 auf X-stellig'
    },
    {
      pattern: /\bpassiv(?:es)?\s+einkommen\s+(?:aufbauen|generieren|erzielen|verdienen)/gi,
      reason: 'Erfolgsversprechen passives Einkommen - § 5 UWG',
      severity: 'high',
      label: 'Passives Einkommen aufbauen'
    },
    {
      pattern: /\bendlich\s+(?:erfolgreich|reich|wohlhabend)\b/gi,
      reason: 'Erfolgsversprechen - § 5 UWG',
      severity: 'high',
      label: 'Endlich erfolgreich'
    },
    {
      pattern: /\b(?:schnell|einfach|leicht)\s+(?:reich|erfolgreich|wohlhabend)\s+(?:werden|sein)\b/gi,
      reason: 'Unrealistische Erfolgsversprechen - § 5 UWG',
      severity: 'high',
      label: 'Schnell reich werden'
    },
    
    // Verkaufs-Sprache
    {
      pattern: /\bkeine\s+(?:verpflichtung|verpflichtungen)\b/gi,
      reason: 'Klassische Verkaufsrhetorik - signalisiert Verkaufsabsicht',
      severity: 'high',
      label: 'Keine Verpflichtung'
    },
    {
      pattern: /\b(?:ganz\s+)?(?:locker|entspannt)\s+und\s+unverbindlich\b/gi,
      reason: 'Klassische Verkaufsrhetorik - suggeriert Unverbindlichkeit',
      severity: 'high',
      label: 'Ganz locker und unverbindlich'
    },
    {
      pattern: /\b(?:ein\s+)?(?:großer|enormer|riesiger)\s+hebel\s+liegt\s+(?:dabei\s+)?in\b/gi,
      reason: 'Business-Verkaufssprache - Erfolgsversprechen',
      severity: 'high',
      label: 'Ein großer Hebel liegt in...'
    },
    {
      pattern: /\bsteuerlich\s+(?:genial|optimal|perfekt|ideal)\b/gi,
      reason: 'Übertreibende Werbesprache - § 5 UWG',
      severity: 'high',
      label: 'Steuerlich genial'
    },
    {
      pattern: /(?:unser|unser\s+exklusives?)\s+angebot/gi,
      reason: 'Klassische Werbesprache - Wettbewerbszentrale 2024',
      severity: 'high',
      label: 'Unser Angebot'
    },
    {
      pattern: /sonderkonditionen?/gi,
      reason: 'Rabatte = Werbung - BGH VI ZR 112/19',
      severity: 'high',
      label: 'Sonderkonditionen'
    },
    {
      pattern: /(?:rabatt|sparen\s+sie|sonderpreis|aktionspreis|frühbucherrabatt|early\s+bird|preisnachlass)/gi,
      reason: 'Preisaktionen = Werbung',
      severity: 'high',
      label: 'Rabatt/Sonderpreis'
    },
    {
      pattern: /\b\d+(?:[.,]\d+)?\s*%\s+(?:rabatt|günstiger|nachlass|reduziert|ersparnis|preisvorteil|discount)\b/gi,
      reason: 'Prozentuale Rabatte = Werbung',
      severity: 'high',
      label: 'X% Rabatt/Nachlass'
    },
    {
      pattern: /\b(?:reduziert|gesenkt|verringert|vermindert)\s+(?:von|um|auf)\s+\d+(?:[.,]\d+)?\s*(?:%|prozent|[€$£])?\b/gi,
      reason: 'Preisreduzierung = Werbung',
      severity: 'high',
      label: 'Reduziert von/um X'
    },
    {
      pattern: /\b(?:nur|jetzt\s+nur|heute\s+nur|aktuell\s+nur)\s+(?:noch\s+)?\d+(?:[.,]\d+)?\s*[€$£¥₹]\b/gi,
      reason: 'Preisdruck mit Zeitbegrenzung = Werbung',
      severity: 'high',
      label: 'Nur noch X € (Preisdruck)'
    },
    {
      pattern: /\b(?:exklusives?|einmaliges?|besonderes?|spezielles?|limitiertes?)\s+(?:angebot|deal|paket|programm|aktion)\b/gi,
      reason: 'Werbesprache mit Exklusivität',
      severity: 'high',
      label: 'Exklusives/Einmaliges Angebot'
    },
    {
      pattern: /\b(?:einmalige[snr]?|einzigartige[snr]?|nie\s+dagewesene[snr]?|außergewöhnliche[snr]?|besondere[snr]?)\s+(?:chance|gelegenheit|möglichkeit|opportunity)\b/gi,
      reason: 'Übertreibung + FOMO = Verkaufsdruck',
      severity: 'high',
      label: 'Einmalige/Einzigartige Chance'
    },
    {
      pattern: /\b(?:geheim|insider|exklusiv)[-\s]?(?:wissen|tipp|information|strategie)\b/gi,
      reason: 'Künstliche Exklusivität = Verkaufssprache',
      severity: 'high',
      label: 'Geheimwissen/Insider-Tipp'
    },
    
    // Kalender-Links und Social Media CTAs
    {
      pattern: /(?:calendly|cal\.com|savvycal|hubspot\/meetings)/gi,
      reason: 'Termin-Links = Werbung - LG Frankfurt 2-03 O 156/24',
      severity: 'high',
      label: 'Kalender-Link'
    },
    {
      pattern: /(?:hier\s+)?(?:klicken|buchen)\s+(?:sie\s+)?(?:hier|für\s+(?:ihren\s+)?termin)/gi,
      reason: 'Termin-Link Aufforderung',
      severity: 'high',
      label: 'Klicken Sie hier'
    },
    {
      pattern: /(?:auf\s+)?(?:youtube|tiktok|instagram)\s+(?:\()?@[\w.]+(?:\))?/gi,
      reason: 'Social Media Call-to-Action mit Handle - führt zu Verkaufskanälen',
      severity: 'high',
      label: 'Social Media Link/Handle'
    },
    
    // Detaillierte Leistungsbeschreibungen mit Bullets/Features
    {
      pattern: /(?:👉|•|\*|\-)\s*(?:\d+\s+)?(?:persönliche|individuelle|exklusive)\s+(?:calls?|gespräche?|sessions?)/gi,
      reason: 'Detaillierte Leistungsbeschreibung = Werbung - BGH I ZR 78/20',
      severity: 'high',
      label: 'Leistungsbeschreibung mit Bullets (X Calls)'
    },
    {
      pattern: /(?:👉|•|\*|\-)\s*.+(?:analyse|bericht|deep-dive|diagnostik|audit)/gi,
      reason: 'Detaillierte Leistungsbeschreibung = Werbung',
      severity: 'high',
      label: 'Leistungsbeschreibung (Analyse/Bericht)'
    },
    {
      pattern: /\b(?:diagnostik|analyse|audit|coaching|beratung)\s+(?:bekommst|erhältst|kriegst|beinhaltet)/gi,
      reason: 'Konkrete Leistungszusage = Werbung',
      severity: 'high',
      label: 'Leistungszusage (Du bekommst/erhältst)'
    },
    {
      pattern: /\b(?:nach|im\s+anschluss\s+an)\s+(?:der|die)?\s+(?:diagnostik|analyse|gespräch|call|session)\s+(?:weißt|kennst|hast|kannst)/gi,
      reason: 'Ergebnisversprechen = Werbung',
      severity: 'high',
      label: 'Ergebnisversprechen (Danach weißt du...)'
    },
    {
      pattern: /\bdarüber\s+sprechen[,\s]+wie\s+(?:dein\s+)?(?:weg|erfolg|wachstum|transformation)/gi,
      reason: 'Verdecktes Verkaufsgespräch - BGH I ZR 78/20',
      severity: 'high',
      label: 'Verdecktes Verkaufsgespräch'
    },
    
    // Social Proof Missbrauch - ALLGEMEIN: Beliebige Zahlen
    {
      pattern: /\b(?:bereits|schon|über|mehr\s+als)\s+(?:über\s+)?\d+(?:[.,]\d+)?(?:k|\.000|tausend|hundert)?\s+(?:zufriedene[nr]?|glückliche[nr]?|erfolgreiche[nr]?)?\s*(?:kunden|teilnehmer|nutzer|anwender|menschen|personen|firmen|unternehmen|coaches|frauen|männer|clients)\s+(?:dabei\s+)?(?:unterstützt|geholfen|begleitet|betreut|gecoacht|trainiert|beraten)\b/gi,
      reason: 'Konkrete Kundenzahlen = Werbung - § 5 UWG',
      severity: 'high',
      label: 'X Kunden/Menschen unterstützt (Social Proof)'
    },
    {
      pattern: /\b(?:bereits|schon|über|mehr\s+als)\s+(?:über\s+)?\d+(?:[.,]\d+)?(?:k|\.000|tausend|hundert)?\s+(?:zufriedene[nr]?|glückliche[nr]?|erfolgreiche[nr]?)?\s*(?:kunden|teilnehmer|nutzer|anwender|menschen|personen|firmen|unternehmen|clients)\b/gi,
      reason: 'Konkrete Kundenzahlen = Werbung - § 5 UWG',
      severity: 'high',
      label: 'X zufriedene Kunden (Social Proof)'
    },
    {
      pattern: /\b(?:tausende|hunderte|viele|zahlreiche|dutzende)\s+(?:kunden|menschen|nutzer|firmen|personen|frauen|männer)?\s*(?:nutzen|verwenden|vertrauen|arbeiten\s+mit|setzen\s+auf)\s+(?:bereits|schon|mir|uns)\b/gi,
      reason: 'Vager Social Proof als Verkaufsargument',
      severity: 'high',
      label: 'Tausende/Viele nutzen bereits'
    },
    {
      pattern: /\b(?:du\s+hast|sie\s+haben)\s+mein\s+leben\s+(?:verändert|transformiert|gerettet)\b/gi,
      reason: 'Testimonial als Erfolgsversprechen = Werbung',
      severity: 'high',
      label: 'Du hast mein Leben verändert (Testimonial)'
    },
    {
      pattern: /\b(?:frauen|männer|menschen|kunden)[,\s]+die\s+mir\s+(?:nach\s+)?(?:unserer\s+)?(?:zusammenarbeit\s+)?sagen[:]\s*[„"]/gi,
      reason: 'Testimonial-Einleitung = Werbung mit Social Proof',
      severity: 'high',
      label: 'Kunden, die mir sagen (Testimonial)'
    },
    
    // Konkurrenz-Bashing
    {
      pattern: /\bin\s+(?:programmen|kursen|coachings)\s+geld\s+verloren\s+haben/gi,
      reason: 'Konkurrenz-Bashing durch Angstmache = unlauter',
      severity: 'high',
      label: 'In Programmen Geld verloren (Konkurrenz-Bashing)'
    },
    {
      pattern: /\bdie\s+viel\s+versprochen[,\s]+aber\s+(?:wenig|nichts)\s+gehalten\s+haben\b/gi,
      reason: 'Konkurrenz-Bashing = unlauterer Wettbewerb',
      severity: 'high',
      label: 'Viel versprochen, wenig gehalten (Konkurrenz-Bashing)'
    },
    {
      pattern: /\bich\s+habe\s+es\s+satt[,\s]+dass\s+sie\s+(?:mir\s+)?erzählen\b/gi,
      reason: 'Emotionale Manipulation durch Pain Point Erzählung',
      severity: 'high',
      label: 'Ich habe es satt, dass... (Manipulation)'
    },
    
    // Pain Points ausnutzen
    {
      pattern: /\b(?:leidest|leiden\s+sie)\s+(?:du\s+)?(?:auch\s+)?unter\b/gi,
      reason: 'Pain Point Manipulation - emotionaler Verkaufsdruck',
      severity: 'high',
      label: 'Leidest du unter... (Pain Point)'
    },
    {
      pattern: /\b(?:hast\s+du|haben\s+sie)\s+(?:auch\s+)?genug\s+von\b/gi,
      reason: 'Pain Point Manipulation - emotionaler Verkaufsdruck',
      severity: 'high',
      label: 'Hast du genug von...'
    },
    {
      pattern: /\bnie\s+wieder\s+(?:schmerzen|probleme|sorgen|stress)\b/gi,
      reason: 'Unrealistisches Heilversprechen/Problemlösung',
      severity: 'high',
      label: 'Nie wieder... (unrealistisch)'
    },
    {
      pattern: /\bvielleicht\s+geht\s+es\s+(?:dir|ihnen|euch)\s+(?:auch\s+)?(?:ähnlich|genauso|so)\b/gi,
      reason: 'Pain Point Manipulation - Identifikation erzwingen',
      severity: 'high',
      label: 'Vielleicht geht es dir ähnlich'
    },
    
    // NEU: Verkaufsrhetorik (ohne X)
    {
      pattern: /\b(?:ganz\s+)?ohne\s+(?:verkaufsdruck|druck|zwang|verpflichtung(?:en)?)\b/gi,
      reason: 'Klassische Verkaufsrhetorik - signalisiert Verkaufsabsicht',
      severity: 'high',
      label: 'Ohne Verkaufsdruck'
    },
    {
      pattern: /\bohne\s+(?:marktschreierei|maske|dich\s+zu\s+verbiegen|dich\s+zu\s+verstellen)\b/gi,
      reason: 'Konkurrenz-Negierung = Verkaufsrhetorik',
      severity: 'high',
      label: 'Ohne Marktschreierei/Maske (Konkurrenz-Abgrenzung)'
    },
    
    // NEU: Einladungs-CTAs mit Zeitangabe - ALLGEMEIN
    {
      pattern: /\b(?:ich\s+)?(?:lade|laden)\s+(?:dich|sie|euch)\s+(?:herzlich\s+)?ein\s+zu\s+einem\s+(?:\d+[-–]?|kurzen|kostenlosen)?\s*(?:minütigen|stündigen)?\s*(?:gespräch|call|austausch|meeting|termin|session)\b/gi,
      reason: 'Call-to-Action mit Einladung = Termin-Aufforderung',
      severity: 'high',
      label: 'Ich lade dich ein zu... Gespräch/Call'
    },
    {
      pattern: /\b(?:zeige|zeigen)\s+(?:ich\s+)?(?:dir|ihnen|euch)\s+in\s+(?:\d+|wenigen|nur)\s+(?:minuten|min)\b/gi,
      reason: 'Direkter CTA mit Zeitversprechen = Verkaufsaufforderung',
      severity: 'high',
      label: 'Zeige ich dir in X Minuten'
    },
    
    // NEU: Direkte Hilfe-Versprechen
    {
      pattern: /\bwie\s+ich\s+(?:dir|ihnen|euch)\s+(?:konkret|genau|wirklich)\s+helfen\s+kann\b/gi,
      reason: 'Direktes Leistungsversprechen = Verkaufsabsicht',
      severity: 'high',
      label: 'Wie ich dir konkret helfen kann'
    },
    {
      pattern: /\b(?:ich|wir)\s+(?:helfe|helfen|unterstütze|unterstützen|berate|beraten|begleite|begleiten)\s+(?:feinfühligen?|sensiblen?|erfolgreichen?|ambitionierten?|vielen?)?\s*(?:frauen|männern|menschen|coaches|firmen|unternehmen|inhabern|personen|unternehmern|gründern)\s+(?:wie\s+)?(?:dir|dich|sie|ihnen|euch)?\s*(?:dabei|darin)?[,\s]*(?:zu|bei|ins)?\s*(?:\w+)?\b/gi,
      reason: 'Direktes Leistungsangebot mit Zielgruppe = Werbung',
      severity: 'high',
      label: 'Ich helfe/unterstütze [Zielgruppe] dabei'
    },
    {
      pattern: /\b(?:ich|wir)\s+(?:arbeite|arbeiten|helfe|helfen|unterstütze|unterstützen|berate|beraten|coache|coachen)\s+(?:mit\s+)?(?:vielen|zahlreichen|hunderten|tausenden|dutzenden|\d+)\s+(?:erfolgreichen|zufriedenen|glücklichen)?\s*(?:frauen|männern|menschen|firmen|unternehmen|kunden|inhabern|coaches|personen|clients)\b/gi,
      reason: 'Vager/Konkreter Social Proof = Verkaufsabsicht signalisieren',
      severity: 'high',
      label: 'Ich arbeite/helfe (mit) vielen/X [Zielgruppe]'
    },
    
    // NEU: Sichtbarkeits- & Marketing-Versprechen
    {
      pattern: /\b(?:sichtbar|sichtbarer)\s+(?:zu\s+)?(?:werden|machen|sein)\b/gi,
      reason: 'Marketing-Erfolgsversprechen = Verkaufsabsicht',
      severity: 'high',
      label: 'Sichtbar werden/machen'
    },
    {
      pattern: /\b(?:dein|ihr|euer)\s+marketing\s+(?:leichter|klarer|magnetischer|effektiver|erfolgreicher)\s+(?:werden|machen)\s+kann\b/gi,
      reason: 'Marketing-Erfolgsversprechen = Verkaufsabsicht',
      severity: 'high',
      label: 'Dein Marketing magnetischer/leichter machen'
    },
    {
      pattern: /\bmagnetisch(?:er|es)?\s+(?:werden|wirken|sein)\b/gi,
      reason: 'Esoterisches Marketing-Versprechen = Verkaufsabsicht',
      severity: 'high',
      label: 'Magnetisch werden (Erfolgsversprechen)'
    },
    
    // NEU: Erfolgsversprechen (Business trägt dich)
    {
      pattern: /\bdamit\s+(?:deine|ihre)\s+(?:praxis|business|arbeit)\s+dich\s+(?:so\s+)?trägt[,\s]+wie\s+(?:du\s+es\s+)?(?:es\s+)?verdienst/gi,
      reason: 'Erfolgsversprechen - suggeriert finanzielle Sicherheit',
      severity: 'high',
      label: 'Damit deine Praxis dich trägt'
    },
    
    // NEU: Exklusives Recruiting / Selektion
    {
      pattern: /\b(?:auf\s+der\s+)?suche\s+nach\s+(?:engagierten|motivierten|ambitionierten)\s+(?:frauen|männern|menschen|personen|coaches)/gi,
      reason: 'Exklusives Recruiting = Verkaufsabsicht mit Selektionsdruck',
      severity: 'high',
      label: 'Suche nach engagierten [X] (exklusiv)'
    },
    {
      pattern: /\bdie\s+bereit\s+sind\s+(?:zu\s+)?(?:wachsen|investieren|sich\s+zu\s+entwickeln)\b/gi,
      reason: 'Selektionskriterium = Verkaufsdruck durch Exklusivität',
      severity: 'high',
      label: 'Die bereit sind zu wachsen'
    }
  ],

  // 🟡 GELB = meistens neutral, aber in Kombination riskant
  YELLOW_TRIGGERS: [
    // Esoterische/unseriöse Begriffe
    {
      pattern: /\b(?:energie|energetisch|energetische[rs]?)\s+(?:arbeit|coaching|branding|beratung|session)/gi,
      reason: 'Esoterische Begriffe wirken unseriös, in Kombination kritisch',
      severity: 'medium',
      label: 'Energie-/Energetische Arbeit'
    },
    {
      pattern: /\b(?:karten\s+leg(?:en|e)|tarot|orakel)\b/gi,
      reason: 'Wahrsagerei - unseriös, fragwürdige Dienstleistung',
      severity: 'medium',
      label: 'Karten legen/Tarot'
    },
    {
      pattern: /\b(?:humanenergetiker|energetiker|geistheiler|schamane)\b/gi,
      reason: 'Esoterische Berufsbezeichnungen - wirken unseriös',
      severity: 'medium',
      label: 'Esoterische Berufsbezeichnung'
    },
    {
      pattern: /\braumhalterin(?:nen)?\b/gi,
      reason: 'Esoterischer Begriff - wirkt unseriös, in Kombination kritisch',
      severity: 'medium',
      label: 'Raumhalterin (esoterisch)'
    },
    {
      pattern: /\b(?:schwingung|frequenz|aura|chakra|manifestier(?:en|ung))/gi,
      reason: 'Esoterische Begriffe ohne wissenschaftliche Basis',
      severity: 'medium',
      label: 'Esoterische Begriffe'
    },
    {
      pattern: /\b(?:körper|energiesystem)\s+(?:und\s+(?:das\s+)?energiesystem\s+)?(?:wieder\s+)?(?:in\s+einklang|ins\s+gleichgewicht)\s+(?:bringen|zu\s+bringen)/gi,
      reason: 'Esoterisch-medizinische Versprechen ohne Basis',
      severity: 'medium',
      label: 'Körper/Energiesystem in Einklang bringen'
    },
    {
      pattern: /\bganz\s+ohne\s+(?:berührung|medikamente|nebenwirkungen|chemie)\b/gi,
      reason: 'Impliziert medizinische Wirkung ohne Zulassung',
      severity: 'medium',
      label: 'Ganz ohne Berührung/Medikamente'
    },
    {
      pattern: /\b(?:spezielle|einzigartige|revolutionäre)\s+methode\s+entwickelt\b/gi,
      reason: 'Übertriebene Einzigartigkeitsbehauptung - § 5 UWG',
      severity: 'medium',
      label: 'Spezielle Methode entwickelt'
    },
    {
      pattern: /\b(?:innere|spirituelle|energetische)\s+(?:klarheit|transformation|heilung)/gi,
      reason: 'Vage esoterische Versprechen',
      severity: 'medium',
      label: 'Innere Klarheit/Transformation'
    },
    {
      pattern: /\bauf\s+(?:mentaler|energetischer)\s+ebene\b/gi,
      reason: 'Vage Formulierung, unklar was gemeint ist',
      severity: 'medium',
      label: 'Auf mentaler/energetischer Ebene'
    },
    {
      pattern: /\b(?:deine|ihre)\s+(?:energie|schwingung|frequenz)\s+(?:hat\s+mich|spüre\s+ich)/gi,
      reason: 'Pseudo-persönliche Ansprache mit esoterischen Begriffen',
      severity: 'medium',
      label: 'Deine Energie hat mich angesprochen'
    },
    {
      pattern: /\bin\s+verbindung\s+mit\s+(?:deiner|ihrer)\s+(?:weiblichkeit|männlichkeit)\b/gi,
      reason: 'Gezieltes Gender-Marketing mit esoterischem Touch',
      severity: 'medium',
      label: 'In Verbindung mit Weiblichkeit/Männlichkeit'
    },
    {
      pattern: /\b(?:starke|erfolgreiche)\s+(?:frauen|männer)\s+wie\s+(?:dich|sie)\b/gi,
      reason: 'Schmeichelei + Zielgruppen-Ansprache = Verkaufsrhetorik',
      severity: 'medium',
      label: 'Starke Frauen/Männer wie dich'
    },
    {
      pattern: /\b(?:feinfühlige[nr]?|sensible[nr]?)\s+(?:frauen|männer|menschen|coaches)\s+wie\s+(?:dir|dich|ihnen|sie)\b/gi,
      reason: 'Zielgruppen-Schmeichelei = Verkaufsrhetorik',
      severity: 'medium',
      label: 'Feinfühlige [X] wie dir'
    },
    {
      pattern: /\bpower[-\s]?(?:frauen|männer|menschen)\b/gi,
      reason: 'Marketing-Schmeichelei zur Zielgruppen-Ansprache',
      severity: 'medium',
      label: 'Powerfrauen/-männer (Marketing-Sprache)'
    },
    {
      pattern: /\b(?:deine|ihre)\s+arbeit\s+(?:als\s+\w+\s+)?hat\s+mich\s+(?:direkt\s+)?(?:berührt|angesprochen|beeindruckt)\b/gi,
      reason: 'Pseudo-persönliche Ansprache = Verkaufstaktik',
      severity: 'medium',
      label: 'Deine Arbeit hat mich berührt'
    },
    {
      pattern: /\bda\s+steckt\s+(?:richtig\s+)?(?:viel\s+)?(?:tiefe|herz|seele|liebe)\s+drin\b/gi,
      reason: 'Schmeichelei = Verkaufstaktik',
      severity: 'medium',
      label: 'Da steckt viel Tiefe/Herz drin'
    },
    {
      pattern: /\bdie\s+(?:tief|mit\s+(?:viel\s+)?feingefühl)\s+arbeiten\b/gi,
      reason: 'Zielgruppen-Schmeichelei',
      severity: 'medium',
      label: 'Die tief arbeiten (Schmeichelei)'
    },
    {
      pattern: /\behemaliger\s+(?:profi|meister|champion|weltmeister|europameister)/gi,
      reason: 'Autorität durch vergangene Titel zur Glaubwürdigkeit',
      severity: 'medium',
      label: 'Ehemaliger Profi/Meister (Autoritätsargument)'
    },
    {
      pattern: /\b(?:auf\s+der\s+)?suche\s+nach\s+(?:.*\s+)?(?:als\s+)?(?:kooperations)?partner(?:n)?\b/gi,
      reason: 'Partnersuche kann verdecktes Verkaufsgespräch sein',
      severity: 'medium',
      label: 'Suche nach Kooperationspartner'
    },
    {
      pattern: /\b(?:spannende|interessante|profitable)\s+synergien?\b/gi,
      reason: 'Business-Sprache, oft Vorstufe zu Verkaufsangebot',
      severity: 'medium',
      label: 'Spannende Synergien'
    },
    {
      pattern: /\bwer\s+weiß[,\s]+was\s+sich\s+(?:hier\s+)?(?:für\s+)?(?:kooperationen?|synergien?|möglichkeiten)\s+ergeben\b/gi,
      reason: 'Vage Kooperationsandeutung - kann Verkaufsabsicht verschleiern',
      severity: 'medium',
      label: 'Wer weiß, was sich ergibt (vage)'
    },
    {
      pattern: /\b(?:marketing|geschäfts|business)[-\s]?ideen\s+austauschen\b/gi,
      reason: 'Business-Sprache, könnte Dienstleistungsangebot sein',
      severity: 'medium',
      label: 'Marketing-Ideen austauschen'
    },
    {
      pattern: /\bschreib(?:en)?\s+(?:mir|uns)\s+gerne\s+und\s+wir\s+(?:machen|vereinbaren|finden)\s+(?:uns\s+)?(?:einen\s+)?termin/gi,
      reason: 'Termin-Aufforderung ohne direkten Link - grenzwertig',
      severity: 'medium',
      label: 'Schreib mir und wir machen Termin'
    },
    {
      pattern: /\bbesonders\s+in\s+diesen\s+(?:herausfordernden|spannenden|schwierigen|unsicheren)\s+zeiten\b/gi,
      reason: 'Kann künstlichen Zeitdruck durch Krisenbezug erzeugen',
      severity: 'medium',
      label: 'Besonders in diesen Zeiten'
    },
    
    {
      pattern: /\b(?:kostenlos|kostenfrei|gratis)(?:es|e|er|em)?\s+(?:strategiegespräch|gespräch|call)\b/gi,
      reason: 'Alleine OK, mit Wertangabe → Werbung',
      severity: 'medium',
      label: 'Kostenloses Strategiegespräch'
    },
    {
      pattern: /\bunverbindlich(?:es|e|er|em)?\s+(?:erstgespräch|gespräch)\b/gi,
      reason: 'OK, aber mit "Wert X €" → ROT',
      severity: 'medium',
      label: 'Unverbindliches Erstgespräch'
    },
    {
      pattern: /\b\d+[-\s]?minütiger\s+(?:call|gespräch)\b/gi,
      reason: 'OK, aber mit "gratis" → ROT',
      severity: 'medium',
      label: '30-minütiger Call'
    },
    {
      pattern: /\bich\s+würde\s+gerne\s+mit\s+(?:ihnen|dir)\s+sprechen\b/gi,
      reason: 'OK, aber mit Angebot → Werbung',
      severity: 'medium',
      label: 'Ich würde gerne sprechen'
    },
    {
      pattern: /\binteresse\s+an\s+einem\s+(?:gespräch|austausch|kennenlernen)\b/gi,
      reason: 'OK, aber mit Preis/Link/Angebot → ROT',
      severity: 'medium',
      label: 'Interesse an Gespräch'
    },
    {
      pattern: /\b(?:kostenlos(?:es|en|er|em)?|gratis|kostenfrei(?:es|en|er|em)?|unentgeltlich(?:es|en|er|em)?|gebührenfrei(?:es|en|er|em)?)(?!\s+(?:erstgespräch|audit|coaching|diagnostik|call|session|beratung))\b/gi,
      reason: 'Kombiniert mit Leistungsbeschreibung = Werbung',
      severity: 'medium',
      label: 'Kostenlos/Gratis (allein)'
    },
    {
      pattern: /\b(?:diagnostik|analyse|audit|deep-dive|session)\b/gi,
      reason: 'Dienstleistungsbegriff - kritisch in Kombination',
      severity: 'medium',
      label: 'Dienstleistungsbegriff'
    },
    {
      pattern: /\b(?:passend|geeignet|perfekt|ideal)\s+für\s+(?:dich|sie)\b/gi,
      reason: 'Verkaufsrhetorik',
      severity: 'medium',
      label: 'Passend für dich (Verkaufsrhetorik)'
    },
    {
      pattern: /\b(?:speziell|extra|genau)\s+für\s+(?:dich|sie)\s+(?:ausgewählt|ausgesucht|entwickelt)\b/gi,
      reason: 'Pseudo-Personalisierung = Verkaufstaktik',
      severity: 'medium',
      label: 'Speziell für dich ausgewählt'
    },
    {
      pattern: /\bich\s+(?:habe|hab)\s+(?:an|bei)\s+(?:dich|dir)\s+gedacht\b/gi,
      reason: 'Pseudo-persönliche Ansprache = Verkaufstaktik',
      severity: 'medium',
      label: 'Ich habe an dich gedacht'
    },
    {
      pattern: /\bdu\s+(?:bist|warst)\s+(?:perfekt|ideal|genau\s+richtig)\s+(?:dafür|hierfür)\b/gi,
      reason: 'Schmeichelei = Verkaufstaktik',
      severity: 'medium',
      label: 'Du bist perfekt dafür'
    },
    {
      pattern: /\bin\s+dem\s+es\s+um\s+(?:dich|sie)\s+geht\b/gi,
      reason: 'Pseudo-Personalisierung = Verkaufstaktik',
      severity: 'medium',
      label: 'In dem es um dich geht'
    },
    {
      pattern: /\bwenn\s+(?:du|sie)\s+(?:spürst|fühlst)[,\s]+dass\s+es\s+an\s+der\s+zeit\s+ist\b/gi,
      reason: 'Emotionale Manipulation = Verkaufsdruck erzeugen',
      severity: 'medium',
      label: 'Wenn du spürst, dass es an der Zeit ist'
    },
    {
      pattern: /\bwenn\s+(?:du|sie)\s+(?:dich|sich)\s+hier\s+wieder[-\s]?erkennst\b/gi,
      reason: 'Identifikations-Zwang = Verkaufstaktik',
      severity: 'medium',
      label: 'Wenn du dich hier wiedererkennst'
    },
    {
      pattern: /\bich\s+sehe\s+so\s+viele\s+(?:wundervolle|tolle|großartige)\s+\w+\b/gi,
      reason: 'Zielgruppen-Schmeichelei als Verkaufseinstieg',
      severity: 'medium',
      label: 'Ich sehe so viele wundervolle [X]'
    },
    {
      pattern: /\bich\s+habe\s+(?:einige\s+)?(?:wertvolle|spannende|interessante)\s+(?:kontakte|strategien|ideen)\s+entwickelt\b/gi,
      reason: 'Autoritätsargument zur Glaubwürdigkeit = Verkaufsvorbereitung',
      severity: 'medium',
      label: 'Ich habe wertvolle Kontakte/Strategien'
    },
    {
      pattern: /\b(?:revolutionär|bahnbrechend|innovativ|neu[-\s]?artig(?:e|es)?)\s+(?:methode|system|ansatz|lösung)\b/gi,
      reason: 'Übertriebene Werbesprache',
      severity: 'medium',
      label: 'Revolutionäre Methode'
    },
    {
      pattern: /\b(?:besser|schneller|effektiver)\s+als\s+(?:alles|die\s+konkurrenz|andere)\b/gi,
      reason: 'Vergleichende Werbung ohne Beleg',
      severity: 'medium',
      label: 'Besser als... (Vergleich)'
    },
    {
      pattern: /\b(?:risiko|bedenken)[-\s]?frei\b/gi,
      reason: 'Absolute Sicherheitsversprechen',
      severity: 'medium',
      label: 'Risikofrei'
    },
    {
      pattern: /\b(?:ohne|kein)\s+(?:risiko|aufwand|zeitverlust)\b/gi,
      reason: 'Unrealistische Versprechen',
      severity: 'medium',
      label: 'Ohne Risiko/Aufwand'
    },
    {
      pattern: /\berste\s+konkrete\s+(?:ansätze|schritte|ideen|strategien)\b/gi,
      reason: 'Leistungsversprechen - kann Verkaufsabsicht signalisieren',
      severity: 'medium',
      label: 'Erste konkrete Ansätze'
    },
    {
      pattern: /\b(?:mit\s+)?(?:viel\s+)?(?:feingefühl|hingabe|herz)\s+(?:und|oder)\s+(?:echter\s+)?hingabe\b/gi,
      reason: 'Emotionale Zielgruppen-Ansprache',
      severity: 'medium',
      label: 'Mit Feingefühl und Hingabe'
    },
    {
      pattern: /\b(?:klarheit|präsenz)\s+und\s+einem\s+marketing[,\s]+das\s+sich\s+nach\s+(?:dir|ihnen)\s+anfühlt\b/gi,
      reason: 'Marketing-Leistungsbeschreibung = Verkaufsabsicht',
      severity: 'medium',
      label: 'Marketing, das sich nach dir anfühlt'
    },
    {
      pattern: /\bwie\s+schwer\s+es\s+sein\s+kann[,\s]+wenn\s+man\s+eigentlich\s+nur\s+helfen\s+will\b/gi,
      reason: 'Pain Point Beschreibung zur Identifikation = Verkaufstaktik',
      severity: 'medium',
      label: 'Wie schwer es sein kann (Pain Point)'
    },
    {
      pattern: /\baber\s+irgendwie\s+keiner\s+sieht[,\s]+was\s+(?:du|man)\s+(?:wirklich\s+)?kann\b/gi,
      reason: 'Pain Point Beschreibung = Verkaufstaktik',
      severity: 'medium',
      label: 'Aber keiner sieht, was du kannst'
    },
    {
      pattern: /\b(?:jemand\s+bist[,\s]+der|du\s+bist\s+jemand[,\s]+der)\s+viel\s+(?:gibt|trägt)\b/gi,
      reason: 'Pseudo-persönliche Schmeichelei = Verkaufstaktik',
      severity: 'medium',
      label: 'Jemand, der viel gibt/trägt'
    },
    {
      pattern: /\bdass\s+es\s+(?:noch\s+)?leichter\s+gehen\s+(?:darf|kann|könnte)\b/gi,
      reason: 'Pseudo-Versprechen von Leichtigkeit',
      severity: 'medium',
      label: 'Dass es leichter gehen darf'
    },
    {
      pattern: /\binnerlich\s+bereit\s+(?:sind|bist)\s+für\s+den\s+nächsten\s+schritt\b/gi,
      reason: 'Emotionale Manipulation - Readiness erzwingen',
      severity: 'medium',
      label: 'Innerlich bereit für den nächsten Schritt'
    },
    {
      pattern: /\b(?:da\s+)?noch\s+mehr\s+möglich\s+ist\s*[–—-]\s*mehr\s+(?:fülle|freiheit|erfolg)\b/gi,
      reason: 'Vage Erfolgsversprechen',
      severity: 'medium',
      label: 'Da noch mehr möglich ist – mehr Fülle'
    },
    {
      pattern: /\bist\s+mein\s+geschenk\s+an\s+(?:dich|sie|euch)\b/gi,
      reason: 'Lockangebot-Rhetorik',
      severity: 'medium',
      label: 'Ist mein Geschenk an dich'
    },
    {
      pattern: /\btauchen\s+wir\s+(?:gemeinsam\s+)?in\s+(?:dein|ihr)\s+energetisch(?:es)?\s+feld\s+ein\b/gi,
      reason: 'Esoterische Leistungsbeschreibung',
      severity: 'medium',
      label: 'Tauchen in dein energetisches Feld'
    },
    {
      pattern: /\bdu\s+wirst\s+(?:erkennen|sehen|spüren|merken)\b/gi,
      reason: 'Ergebnisversprechen',
      severity: 'medium',
      label: 'Du wirst erkennen/sehen'
    },
    {
      pattern: /\bdu\s+musst\s+nichts\s+(?:vorbereiten|mitbringen|tun)\b/gi,
      reason: 'Klassische Verkaufsrhetorik - senkt Hemmschwelle',
      severity: 'medium',
      label: 'Du musst nichts vorbereiten'
    },
    {
      pattern: /\bnur\s+(?:offen|bereit)\s+sein\b/gi,
      reason: 'Manipulative Formulierung - suggeriert Einfachheit',
      severity: 'medium',
      label: 'Nur offen sein'
    },
    {
      pattern: /\bauf\s+einer\s+tieferen\s+ebene\s+(?:kennenzulernen|zu\s+verstehen)\b/gi,
      reason: 'Esoterische Sprache',
      severity: 'medium',
      label: 'Auf einer tieferen Ebene'
    },
    {
      pattern: /\bwenn\s+es\s+sich\s+(?:wirklich\s+)?stimmig\s+anfühlt\b/gi,
      reason: 'Esoterische Sprache - suggeriert Unverbindlichkeit',
      severity: 'medium',
      label: 'Wenn es sich stimmig anfühlt'
    },
    {
      pattern: /\bwenn\s+(?:du|sie)\s+spürst[,\s]+dass\s+(?:dich\s+)?das\s+ruft\b/gi,
      reason: 'Emotionale Manipulation - spirituelle Sprache',
      severity: 'medium',
      label: 'Wenn du spürst, dass dich das ruft'
    },
    {
      pattern: /\b(?:bist\s+du|sind\s+sie|seid\s+ihr)\s+bereit\s+(?:für|dich|sich|euch\s+)?(?:zu\s+öffnen\s+für|zu)?\s*(?:wachstum|fülle|veränderung|transformation|erfolg|den\s+nächsten\s+schritt|mehr|neue\s+wege|investment)\b/gi,
      reason: 'Commitment-Frage = Verkaufstaktik',
      severity: 'medium',
      label: 'Bist du bereit für... (Commitment)'
    },
    {
      pattern: /\b(?:mit|von)\s+liebe\s+(?:und|&|,)\s+klarheit\b/gi,
      reason: 'Esoterische E-Mail-Signatur',
      severity: 'medium',
      label: 'Mit Liebe und Klarheit (esoterische Signatur)'
    },
    {
      pattern: /\bvon\s+herzen\b/gi,
      reason: 'Esoterische E-Mail-Signatur',
      severity: 'medium',
      label: 'Von Herzen (esoterische Signatur)'
    },
    {
      pattern: /\bvon\s+herz\s+zu\s+herz\b/gi,
      reason: 'Esoterische E-Mail-Signatur',
      severity: 'medium',
      label: 'Von Herz zu Herz'
    },
    {
      pattern: /\b(?:fülle|erfolg|leichtigkeit)\s+(?:wieder\s+)?in\s+bewegung\s+(?:kommen|bringen)\b/gi,
      reason: 'Esoterisches Erfolgsversprechen',
      severity: 'medium',
      label: 'Fülle in Bewegung bringen'
    },
    {
      pattern: /\bes\s+geht\s+(?:nicht\s+)?(?:darum|dabei)[,\s]+(?:etwas\s+zu\s+)?[„"]?reparieren[„"]?\b/gi,
      reason: 'Pseudo-Abgrenzung von Therapie',
      severity: 'medium',
      label: 'Es geht nicht ums Reparieren'
    },
    {
      pattern: /\b(?:an\s+etwas|dich\s+an\s+das)\s+(?:zu\s+)?erinnern[,\s]+(?:das|was)\s+längst\s+in\s+dir\s+angelegt\s+ist\b/gi,
      reason: 'Esoterische Pseudo-Weisheit',
      severity: 'medium',
      label: 'An etwas erinnern, das in dir angelegt ist'
    },
    {
      pattern: /\bich\s+(?:bin|wurde)\s+auf\s+(?:dich|sie)\s+aufmerksam\s+geworden\b/gi,
      reason: 'Pseudo-persönliche Ansprache bei Cold Email',
      severity: 'medium',
      label: 'Ich bin auf dich aufmerksam geworden'
    },
    {
      pattern: /\b(?:hatte|habe)\s+sofort\s+das\s+gefühl[,\s]+dass\s+(?:du|sie)\b/gi,
      reason: 'Pseudo-persönliche Ansprache = Verkaufstaktik',
      severity: 'medium',
      label: 'Hatte sofort das Gefühl, dass du...'
    },
    {
      pattern: /\bdie\s+bereit\s+für\s+mehr\s+sind\b/gi,
      reason: 'Exklusivitäts-Rhetorik',
      severity: 'medium',
      label: 'Die bereit für mehr sind'
    },
    {
      pattern: /\b(?:nach|aufgrund)\s+(?:dem|dessen)[,\s]+was\s+(?:ich\s+)?gesehen\s+habe[,\s]+spüre\s+ich\b/gi,
      reason: 'Pseudo-persönliche Selektion = Schmeichelei',
      severity: 'medium',
      label: 'Nach dem, was ich gesehen habe, spüre ich'
    },
    {
      pattern: /\bdu\s+bist\s+eine\s+davon\b/gi,
      reason: 'Exklusivitäts-Schmeichelei',
      severity: 'medium',
      label: 'Du bist eine davon'
    },
    {
      pattern: /\b(?:nach|seit|mit)\s+(?:über|mehr\s+als)?\s*\d+\+?\s+jahren?\s+(?:im|in|der|an)?\s*(?:business|branche|markt|erfahrung|praxis|geschäft)\b/gi,
      reason: 'Autoritätsargument zur Glaubwürdigkeit',
      severity: 'medium',
      label: 'Nach/Seit X Jahren im Business/Erfahrung'
    },
    {
      pattern: /\bwenn\s+(?:du|sie)\s+magst[,\s]+(?:können\s+wir|lass\s+uns|können\s+wir\s+uns)\b/gi,
      reason: 'Pseudo-unverbindlicher CTA',
      severity: 'medium',
      label: 'Wenn du magst, können wir...'
    },
    {
      pattern: /\b(?:kennst\s+du|kennen\s+sie|kennt\s+ihr)\s+jemanden[,\s]+(?:der|für\s+den)\s+(?:das|hier)\s+(?:gerade\s+)?(?:relevant|interessant|spannend)\s+(?:sein\s+)?(?:könnte|wäre)\b/gi,
      reason: 'Referral-Frage = Verkaufstaktik zur Reichweiten-Erhöhung',
      severity: 'medium',
      label: 'Kennst du jemanden, für den das relevant sein könnte'
    },
    {
      pattern: /\bwürde\s+mich\s+(?:total|sehr|riesig)?\s*(?:über\s+)?(?:einen\s+)?(?:austausch|kontakt|kurzen\s+call)\s+freuen\b/gi,
      reason: 'Pseudo-freundlicher CTA = Verkaufstaktik',
      severity: 'medium',
      label: 'Würde mich total über einen Austausch freuen'
    },
    {
      pattern: /\bfalls\s+das\s+(?:spannend|interessant)\s+(?:klingt|für\s+(?:dich|sie)\s+ist)\b/gi,
      reason: 'Manipulative Formulierung - Zustimmung voraussetzen',
      severity: 'medium',
      label: 'Falls das spannend klingt'
    },
    {
      pattern: /\bwo\s+ich\s+alle\s+fragen\s+(?:ganz\s+)?unverbindlich\s+beantworten\s+kann\b/gi,
      reason: 'Leistungsbeschreibung mit Unverbindlichkeits-Rhetorik',
      severity: 'medium',
      label: 'Wo ich alle Fragen unverbindlich beantworten kann'
    },
    {
      pattern: /\bbesser\s+aufgesetzte\s+(?:setups|strukturen|systeme)\b/gi,
      reason: 'Vergleichende Werbung - impliziert Wettbewerbsvorteil',
      severity: 'medium',
      label: 'Besser aufgesetzte Setups'
    },
    {
      pattern: /\bich\s+lebe\s+selbst\s+(?:international|im\s+ausland)\b/gi,
      reason: 'Autoritätsargument durch Lifestyle-Beweis',
      severity: 'medium',
      label: 'Ich lebe selbst international'
    },
    {
      pattern: /\b(?:kompass|diagnose|analyse|audit)[-\s]?(?:call|gespräch|session)\b/gi,
      reason: 'Branded Service-Namen = Dienstleistungsangebot',
      severity: 'medium',
      label: 'Kompass-Call/Diagnose-Call (Branded Service)'
    }
  ],

  // 📧 SPAM = Deliverability Risk (Email Algorithm Triggers)
  SPAM_TRIGGERS: [
    // ── Formatting Red Flags ──
    {
      pattern: /\b[A-ZÄÖÜ]{5,}\b/g,
      reason: 'All-caps words are a top spam filter trigger. Use normal capitalization.',
      severity: 'spam',
      label: 'ALL CAPS Word'
    },
    {
      pattern: /!{2,}/g,
      reason: 'Multiple exclamation marks strongly trigger spam filters.',
      severity: 'spam',
      label: 'Excessive Exclamation Marks'
    },
    {
      pattern: /\?{3,}/g,
      reason: 'Excessive question marks can trigger spam filters.',
      severity: 'spam',
      label: 'Excessive Question Marks'
    },
    {
      pattern: /[$€£¥]{2,}/g,
      reason: 'Repeated currency symbols are a classic spam signal.',
      severity: 'spam',
      label: 'Repeated Currency Symbols'
    },

    // ── English: Financial Spam ──
    {
      pattern: /\b(?:earn|make)\s+(?:extra\s+)?money\b/gi,
      reason: 'Financial promise — top spam trigger across all providers.',
      severity: 'spam',
      label: 'Earn/Make Money'
    },
    {
      pattern: /\bfree\s+money\b/gi,
      reason: 'Classic spam phrase flagged by all major filters.',
      severity: 'spam',
      label: 'Free Money'
    },
    {
      pattern: /\bcash\s+(?:bonus|prize|reward)\b/gi,
      reason: 'Financial incentive language triggers spam filters.',
      severity: 'spam',
      label: 'Cash Bonus/Prize'
    },
    {
      pattern: /\bdouble\s+your\s+(?:income|money|salary|revenue|investment)\b/gi,
      reason: 'Unrealistic financial promise — strong spam signal.',
      severity: 'spam',
      label: 'Double Your Income/Money'
    },
    {
      pattern: /\b(?:extra|passive)\s+(?:income|cash)\b/gi,
      reason: 'Income promise language flagged by email filters.',
      severity: 'spam',
      label: 'Extra/Passive Income'
    },
    {
      pattern: /\bmillion\s+(?:dollar|euro)\b/gi,
      reason: 'Large monetary reference — classic spam indicator.',
      severity: 'spam',
      label: 'Million Dollar/Euro'
    },
    {
      pattern: /\b(?:get\s+rich|get\s+paid)\s+(?:quick|fast|now|today)?\b/gi,
      reason: 'Get-rich-quick language is heavily filtered.',
      severity: 'spam',
      label: 'Get Rich/Paid Quick'
    },
    {
      pattern: /\blowest\s+price\b/gi,
      reason: 'Aggressive pricing language triggers filters.',
      severity: 'spam',
      label: 'Lowest Price'
    },
    {
      pattern: /\bincredible\s+(?:deal|offer|discount)\b/gi,
      reason: 'Overhyped deal language flagged by spam filters.',
      severity: 'spam',
      label: 'Incredible Deal/Offer'
    },
    {
      pattern: /\b(?:huge|massive|big)\s+(?:discount|sale|savings?)\b/gi,
      reason: 'Aggressive promotional language triggers spam filters.',
      severity: 'spam',
      label: 'Huge/Massive Discount'
    },
    {
      pattern: /\bspecial\s+promotion\b/gi,
      reason: 'Promotional language commonly flagged by filters.',
      severity: 'spam',
      label: 'Special Promotion'
    },

    // ── English: Urgency Spam ──
    {
      pattern: /\bact\s+(?:now|immediately|fast)\b/gi,
      reason: 'Urgency pressure — one of the most flagged spam phrases.',
      severity: 'spam',
      label: 'Act Now/Immediately'
    },
    {
      pattern: /\blimited\s+time\s+(?:offer|only|deal)\b/gi,
      reason: 'Time pressure phrase heavily flagged by filters.',
      severity: 'spam',
      label: 'Limited Time Offer'
    },
    {
      pattern: /\bdon'?t\s+miss\s+(?:out|this)\b/gi,
      reason: 'FOMO language triggers spam filters.',
      severity: 'spam',
      label: "Don't Miss Out"
    },
    {
      pattern: /\b(?:expires?|expiring)\s+(?:today|soon|now|tonight)\b/gi,
      reason: 'Artificial urgency is a spam filter trigger.',
      severity: 'spam',
      label: 'Expires Today/Soon'
    },
    {
      pattern: /\bwhat\s+are\s+you\s+waiting\s+for\b/gi,
      reason: 'Pressure question flagged by spam algorithms.',
      severity: 'spam',
      label: 'What Are You Waiting For'
    },
    {
      pattern: /\bonce\s+in\s+a\s+lifetime\b/gi,
      reason: 'Overhyped urgency — classic spam signal.',
      severity: 'spam',
      label: 'Once In A Lifetime'
    },
    {
      pattern: /\burgent(?:ly)?\b/gi,
      reason: '"Urgent" is one of the most flagged words by email filters.',
      severity: 'spam',
      label: 'Urgent'
    },
    {
      pattern: /\b(?:final|last)\s+(?:notice|warning|reminder|call)\b/gi,
      reason: 'Threat-like urgency triggers spam filters.',
      severity: 'spam',
      label: 'Final/Last Notice'
    },

    // ── English: Action Commands ──
    {
      pattern: /\bbuy\s+(?:now|today|directly)\b/gi,
      reason: 'Direct purchase command heavily flagged by filters.',
      severity: 'spam',
      label: 'Buy Now'
    },
    {
      pattern: /\border\s+(?:now|today)\b/gi,
      reason: 'Direct order command triggers spam filters.',
      severity: 'spam',
      label: 'Order Now'
    },
    {
      pattern: /\bsign\s+up\s+(?:now|today|for\s+free|here)\b/gi,
      reason: 'Sign-up command commonly flagged by filters.',
      severity: 'spam',
      label: 'Sign Up Now/Free'
    },
    {
      pattern: /\bclick\s+(?:here|below|now|this)\b/gi,
      reason: '"Click here" is one of the most penalized phrases by email filters.',
      severity: 'spam',
      label: 'Click Here/Below'
    },
    {
      pattern: /\bcall\s+now\b/gi,
      reason: 'Direct call command triggers spam filters.',
      severity: 'spam',
      label: 'Call Now'
    },
    {
      pattern: /\bsubscribe\s+(?:now|here|today)\b/gi,
      reason: 'Subscription command commonly flagged.',
      severity: 'spam',
      label: 'Subscribe Now'
    },
    {
      pattern: /\bvisit\s+(?:our\s+)?(?:website|site)\b/gi,
      reason: 'Website redirect language can trigger filters in cold emails.',
      severity: 'spam',
      label: 'Visit Our Website'
    },

    // ── English: Trust Manipulation ──
    {
      pattern: /\bthis\s+is\s+not\s+spam\b/gi,
      reason: 'Claiming "not spam" is the strongest spam signal — filters interpret this as an admission.',
      severity: 'spam',
      label: 'This Is Not Spam'
    },
    {
      pattern: /\byou(?:'ve|\s+have)\s+been\s+(?:selected|chosen)\b/gi,
      reason: 'Fake selection claim — classic phishing/spam signal.',
      severity: 'spam',
      label: 'You Have Been Selected'
    },
    {
      pattern: /\bcongratulations?\b/gi,
      reason: '"Congratulations" is heavily associated with spam/phishing.',
      severity: 'spam',
      label: 'Congratulations'
    },
    {
      pattern: /\byou(?:'re|\s+are)\s+a\s+winner\b/gi,
      reason: 'Winner claims are classic spam/scam signals.',
      severity: 'spam',
      label: "You're A Winner"
    },
    {
      pattern: /\bdear\s+(?:friend|sir|madam|customer|user|member)\b/gi,
      reason: 'Generic salutation is a strong spam indicator in cold emails.',
      severity: 'spam',
      label: 'Dear Friend/Sir/Madam'
    },
    {
      pattern: /\bno\s+(?:strings\s+attached|catch|obligation)\b/gi,
      reason: '"No catch" language signals too-good-to-be-true offers.',
      severity: 'spam',
      label: 'No Strings Attached/No Catch'
    },
    {
      pattern: /\b(?:100%|completely|totally|absolutely)\s+(?:free|guaranteed|safe|secure)\b/gi,
      reason: 'Absolute claims are strong spam triggers.',
      severity: 'spam',
      label: '100%/Completely Free/Guaranteed'
    },
    {
      pattern: /\brisk[\s-]?free\b/gi,
      reason: '"Risk-free" is a well-known spam trigger word.',
      severity: 'spam',
      label: 'Risk-Free'
    },
    {
      pattern: /\bguaranteed\s+(?:results?|income|success|returns?)\b/gi,
      reason: 'Guaranteed outcome promises are flagged by all major filters.',
      severity: 'spam',
      label: 'Guaranteed Results/Success'
    },
    {
      pattern: /\bas\s+seen\s+on\b/gi,
      reason: '"As seen on" claims are flagged as promotional spam.',
      severity: 'spam',
      label: 'As Seen On'
    },
    {
      pattern: /\bno\s+(?:credit\s+card|purchase)\s+(?:needed|required|necessary)\b/gi,
      reason: 'Credit card disclaimer signals promotional intent.',
      severity: 'spam',
      label: 'No Credit Card Required'
    },
    {
      pattern: /\b(?:opt[\s-]?in|unsubscribe|opt[\s-]?out)\b/gi,
      reason: 'Subscription management language in cold emails signals bulk sending.',
      severity: 'spam',
      label: 'Opt-In/Unsubscribe'
    },

    // ── English: Health/Wellness Spam ──
    {
      pattern: /\blos(?:e|ing)\s+weight\b/gi,
      reason: 'Weight loss claims are heavily flagged spam triggers.',
      severity: 'spam',
      label: 'Lose Weight'
    },
    {
      pattern: /\banti[\s-]?aging\b/gi,
      reason: 'Anti-aging claims trigger health-related spam filters.',
      severity: 'spam',
      label: 'Anti-Aging'
    },
    {
      pattern: /\bmiracle\s+(?:cure|solution|product|pill|supplement)\b/gi,
      reason: 'Miracle claims are top spam triggers.',
      severity: 'spam',
      label: 'Miracle Cure/Solution'
    },
    {
      pattern: /\bonline\s+pharmacy\b/gi,
      reason: 'Online pharmacy references are heavily flagged.',
      severity: 'spam',
      label: 'Online Pharmacy'
    },

    // ── German: Spam-specific (not covered by legal rules) ──
    {
      pattern: /\bdies\s+ist\s+kein\s+spam\b/gi,
      reason: '"Dies ist kein Spam" ist das stärkste Spam-Signal — Filter werten dies als Eingeständnis.',
      severity: 'spam',
      label: 'Dies ist kein Spam'
    },
    {
      pattern: /\bsie\s+wurden\s+ausgewählt\b/gi,
      reason: 'Falsche Selektionsbehauptung — typisches Phishing/Spam-Signal.',
      severity: 'spam',
      label: 'Sie wurden ausgewählt'
    },
    {
      pattern: /\bherzlichen\s+glückwunsch\b/gi,
      reason: '"Herzlichen Glückwunsch" wird stark mit Spam/Phishing assoziiert.',
      severity: 'spam',
      label: 'Herzlichen Glückwunsch'
    },
    {
      pattern: /\bletzte\s+(?:warnung|erinnerung|mahnung)\b/gi,
      reason: 'Drohende Dringlichkeit triggert Spam-Filter.',
      severity: 'spam',
      label: 'Letzte Warnung/Erinnerung'
    },
    {
      pattern: /\bnur\s+heute\b/gi,
      reason: '"Nur heute" erzeugt künstlichen Zeitdruck — Spam-Signal.',
      severity: 'spam',
      label: 'Nur heute'
    },
    {
      pattern: /\bsofort\s+(?:herunterladen|downloaden|zugreifen|öffnen)\b/gi,
      reason: 'Sofort-Download/Zugriff-Aufforderung signalisiert Spam.',
      severity: 'spam',
      label: 'Sofort herunterladen/zugreifen'
    },
    {
      pattern: /\bkein\s+spam\b/gi,
      reason: '"Kein Spam" zu behaupten löst genau das Gegenteil aus.',
      severity: 'spam',
      label: 'Kein Spam'
    },
    {
      pattern: /\bgewinner\b/gi,
      reason: '"Gewinner"-Behauptungen sind typische Spam/Scam-Signale.',
      severity: 'spam',
      label: 'Gewinner'
    },
    {
      pattern: /\blieber\s+(?:freund|kunde|nutzer|interessent|leser)\b/gi,
      reason: 'Generische Anrede ist ein starker Spam-Indikator bei Cold Emails.',
      severity: 'spam',
      label: 'Lieber Freund/Kunde (generic)'
    },
    {
      pattern: /\babmeld(?:en|ung|elink)\b/gi,
      reason: 'Abmelde-Sprache in Cold Emails signalisiert Massenversand.',
      severity: 'spam',
      label: 'Abmelden/Abmeldelink'
    },
    {
      pattern: /\babnehmen\s+(?:ohne|schnell|leicht|einfach)\b/gi,
      reason: 'Gewichtsverlust-Versprechen triggern Health-Spam-Filter.',
      severity: 'spam',
      label: 'Abnehmen ohne/schnell'
    },
    {
      pattern: /\bkonto\s+(?:gesperrt|verifizieren|bestätigen|aktualisieren)\b/gi,
      reason: 'Kontosicherheits-Sprache ist das #1 Phishing-Signal.',
      severity: 'spam',
      label: 'Konto gesperrt/verifizieren (Phishing)'
    },
    {
      pattern: /\bpasswort\s+(?:zurücksetzen|ändern|bestätigen|aktualisieren)\b/gi,
      reason: 'Passwort-bezogene Aufforderungen sind typische Phishing-Signale.',
      severity: 'spam',
      label: 'Passwort zurücksetzen (Phishing)'
    },
    {
      pattern: /\bverifizieren\s+sie\s+(?:ihr|ihre)\b/gi,
      reason: 'Verifizierungs-Aufforderungen triggern Phishing-Filter.',
      severity: 'spam',
      label: 'Verifizieren Sie Ihr... (Phishing)'
    },
    {
      pattern: /\b(?:bester|niedrigster|günstigster)\s+preis\b/gi,
      reason: 'Superlativ-Preisangaben sind typische Spam-Signale.',
      severity: 'spam',
      label: 'Bester/Niedrigster Preis'
    },
    {
      pattern: /\b(?:sensationell|unglaublich|unfassbar|wahnsinnig)\s+(?:günstig|billig|preiswert)\b/gi,
      reason: 'Übertriebene Preissprache triggert Spam-Filter.',
      severity: 'spam',
      label: 'Sensationell günstig'
    },
    {
      pattern: /\bfor\s+free\b/gi,
      reason: '"For free" is a well-known spam trigger phrase.',
      severity: 'spam',
      label: 'For Free'
    },
    {
      pattern: /\bno\s+(?:cost|charge|fee)\b/gi,
      reason: '"No cost" language triggers promotional spam filters.',
      severity: 'spam',
      label: 'No Cost/Charge/Fee'
    },
    {
      pattern: /\b(?:apply|register|enroll)\s+now\b/gi,
      reason: 'Enrollment urgency commands trigger spam filters.',
      severity: 'spam',
      label: 'Apply/Register Now'
    },
    {
      pattern: /\b(?:don'?t|do\s+not)\s+delete\b/gi,
      reason: '"Don\'t delete" is a classic spam phrase — signals desperation.',
      severity: 'spam',
      label: "Don't Delete"
    },
    {
      pattern: /\binstant\s+(?:access|download|results?)\b/gi,
      reason: '"Instant" promises are flagged as too-good-to-be-true.',
      severity: 'spam',
      label: 'Instant Access/Results'
    },
    {
      pattern: /\bwhile\s+(?:supplies?|stocks?)\s+last\b/gi,
      reason: 'Scarcity language triggers spam filters.',
      severity: 'spam',
      label: 'While Supplies Last'
    }
  ],

  // 🟢 GRÜN = 100% sicher (keine Werbung)
  GREEN_PATTERNS: [
    /gibt\s+es\s+bei\s+ihnen\s+(?:aktuell\s+)?themen\s+zu/i,
    /wäre\s+ein\s+(?:kurzer\s+)?austausch\s+interessant/i,
    /interesse\s+an\s+einem\s+kennenlernen/i,
    /möchten\s+sie\s+sich\s+mal\s+austauschen/i,
    /wollten\s+mal\s+unverbindlich\s+connecten/i,
    /kurzer\s+austausch\s+möglich/i,
    /falls\s+ja[,\s]+gerne\s+antworten/i,
    /einfach\s+(?:kurz\s+)?antworten\s+oder\s+ignorieren/i
  ]
};

/**
 * Kategorisiert die gefundenen Verstöße
 */
export const getViolationCategory = (violations) => {
  const redCount = violations.filter(v => v.severity === 'high').length;
  const yellowCount = violations.filter(v => v.severity === 'medium').length;

  // CRITICAL: Many red violations or combination of red + yellow
  if (redCount >= 5 || (redCount >= 3 && yellowCount >= 2)) {
    return {
      level: 'CRITICAL',
      color: '#b91c1c',
      label: '⚠️ EXTREMELY CRITICAL',
      icon: '🚨',
      message: 'MASSIVE risk! This email is clearly advertising under § 7 UWG.'
    };
  } else if (redCount >= 3) {
    return {
      level: 'CRITICAL',
      color: '#dc2626',
      label: 'Critical',
      icon: '🔴',
      message: 'Very high risk! Multiple forbidden phrases found.'
    };
  } else if (redCount >= 1) {
    return {
      level: 'HIGH',
      color: '#ef4444',
      label: 'High Risk',
      icon: '🔴',
      message: 'High risk! Sales language detected.'
    };
  } else if (yellowCount >= 4) {
    return {
      level: 'MEDIUM',
      color: '#f59e0b',
      label: 'Medium Risk',
      icon: '🟡',
      message: 'Caution! Many critical phrases in combination.'
    };
  } else if (yellowCount >= 2 || (yellowCount >= 1 && redCount > 0)) {
    return {
      level: 'MEDIUM',
      color: '#f59e0b',
      label: 'Medium Risk',
      icon: '🟡',
      message: 'Caution! Critical phrases in combination.'
    };
  } else if (yellowCount >= 1) {
    return {
      level: 'LOW',
      color: '#fbbf24',
      label: 'Low Risk',
      icon: '🟡',
      message: 'Attention: Wording is borderline.'
    };
  } else {
    return {
      level: 'SAFE',
      color: '#10b981',
      label: 'Safe',
      icon: '🟢',
      message: 'No problematic wording found.'
    };
  }
};

/**
 * Prüft auf positive (grüne) Muster
 */
export const checkGreenPatterns = (text) => {
  return ComplianceRules.GREEN_PATTERNS.filter(pattern => pattern.test(text));
};

/**
 * Compliance Guide für rechtssichere E-Mails
 * Umfassende Dokumentation zu DSGVO/UWG
 */
export const COMPLIANCE_GUIDE = {
  sections: [
    {
      title: "1. Grundprinzip: Wann ist eine E-Mail Werbung?",
      content: `Nach § 7 Abs. 2 Nr. 2 UWG ist jede E-Mail ohne Einwilligung verboten, wenn sie Werbung ist.

Werbung bedeutet:
• Jede Nachricht, die den Absatz einer Leistung fördert (BGH I ZR 78/20)
• Auch wenn sie kostenlos genannt wird
• Auch wenn sie unverbindlich klingt
• Auch wenn kein Preis drinsteht, aber eine Verkaufsabsicht sichtbar ist`
    },
    {
      title: "2. Die 3 Zonen: Rot – Gelb – Grün",
      redZone: {
        title: "🔴 ROT = Hohe Abmahngefahr",
        examples: [
          { phrase: "Kostenloses Erstgespräch + Angebot", reason: "Lockangebot + Verkauf", case: "BGH I ZR 78/20" },
          { phrase: "Jetzt Termin buchen", reason: "Direkter Call to Action", case: "OLG Hamburg 5 U 92/22" },
          { phrase: "Nur noch 3 Plätze frei", reason: "Verknappung", case: "LG Berlin 52 O 128/23" },
          { phrase: "Gratis Coaching (Wert X €)", reason: "Wertangabe = Verkaufsabsicht", case: "OLG Köln 6 U 68/22" },
          { phrase: "Unser Angebot für Sie", reason: "Klassische Werbesprache", case: "Wettbewerbszentrale 2024" },
          { phrase: "Sonderkonditionen", reason: "Rabatte = Werbung", case: "BGH VI ZR 112/19" }
        ],
        elements: "Wertangabe, Gratis-Angebot, Termin-Link, Verknappung, Leistungsversprechen, Worte wie 'buchen', 'sparen', 'Angebot'"
      },
      yellowZone: {
        title: "🟡 GELB = In Kombination riskant",
        examples: [
          { phrase: "Kostenloses Strategiegespräch", ok: "Alleine ok", critical: "+ Wertangabe → Werbung" },
          { phrase: "Unverbindliches Erstgespräch", ok: "OK", critical: "+ 'Wert X €' → ROT" },
          { phrase: "30-minütiger Call", ok: "OK", critical: "+ 'gratis' → ROT" },
          { phrase: "Ich würde gerne sprechen", ok: "OK", critical: "+ Angebot → Werbung" }
        ]
      },
      greenZone: {
        title: "🟢 GRÜN = 100% sicher",
        examples: [
          { phrase: "Gibt es bei Ihnen Themen zu …?", reason: "Offene Frage, kein Angebot" },
          { phrase: "Wäre ein kurzer Austausch interessant?", reason: "Kein Verkaufsdruck" },
          { phrase: "Interesse an einem Kennenlernen?", reason: "Neutral" },
          { phrase: "Kurzer Austausch möglich?", reason: "Kein 'gratis', kein Angebot" }
        ],
        rule: "Solange keine Leistung beschrieben wird, ist es KEINE Werbung."
      }
    },
    {
      title: "3. Die wichtigsten Urteile (2022–2025)",
      cases: [
        {
          name: "BGH I ZR 78/20 (2022)",
          rule: "Werbung ist jede Nachricht, die erkennbar den Absatz fördern soll – auch wenn sie als kostenlos bezeichnet wird."
        },
        {
          name: "OLG München 29 U 514/23",
          rule: "Bloße Anfrage nach einem Gesprächstermin ist keine Werbung."
        },
        {
          name: "OLG Köln 6 U 68/22",
          rule: "Wertangaben ('Wert 997 €'), Verknappung oder Buchungswörter lassen auf Werbung schließen."
        },
        {
          name: "LG Berlin 52 O 128/23",
          rule: "'Wäre ein Austausch interessant?' ist unproblematisch."
        },
        {
          name: "LG Frankfurt 2-03 O 156/24",
          rule: "Kalender-Links begründen Werbecharakter."
        }
      ]
    },
    {
      title: "4. VERBOTENE Wörter (🔴 Rot)",
      categories: [
        {
          name: "Lockangebote",
          words: ["gratis", "kostenlos", "kostenfrei", "unentgeltlich", "gebührenfrei", "umsonst", "ohne Kosten", "als Geschenk", "schenke dir"]
        },
        {
          name: "Wertangaben",
          words: ["im Wert von X €", "normalerweise X €", "Wert: X €", "statt X €"]
        },
        {
          name: "Verknappung",
          words: ["nur noch X Plätze", "limitiert", "letzte Chance", "jetzt oder nie", "fast ausgebucht"]
        },
        {
          name: "Call-to-Action",
          words: ["jetzt buchen", "jetzt anmelden", "klick hier", "melde dich an", "verpasse nicht", "bevor es zu spät ist", "ich lade dich ein zu X-minütigem Gespräch", "zeige ich dir in X Minuten"]
        },
        {
          name: "Erfolgsversprechen",
          words: ["6-/7-stellige Umsätze", "Einkommenssprung", "Geld leichter fließen", "finanzielle Freiheit", "passives Einkommen", "sichtbar werden", "magnetischer werden", "damit deine Praxis dich trägt", "mehr aus Umsatz herausholen", "ohne mehr Umsatz machen zu müssen", "günstigere Kosten"]
        },
        {
          name: "Verkaufs-Sprache",
          words: ["unser Angebot", "Sonderkonditionen", "Rabatt", "keine Verpflichtung", "Geld-zurück-Garantie", "ohne Verkaufsdruck", "ohne Marktschreierei", "wie ich dir konkret helfen kann", "ganz locker und unverbindlich", "steuerlich genial"]
        },
        {
          name: "Business Social Proof",
          words: ["ich arbeite mit vielen [X]", "bereits über 1.000 Menschen unterstützt", "ich lebe selbst international"]
        },
        {
          name: "Heilversprechen (⚠️ EXTREM KRITISCH)",
          words: ["Heilung", "Krankheiten heilen", "Schmerzen lösen", "der Heilung verschrieben"]
        },
        {
          name: "Exklusives Recruiting",
          words: ["suche nach engagierten [X]", "die bereit sind zu wachsen", "ich helfe [Zielgruppe] wie dir"]
        },
        {
          name: "Pseudowissenschaft (⚠️ KRITISCH)",
          words: ["Geldfluss/Money Frequency", "energetisches Feld", "Frequenz aktivieren", "Geldblockaden lösen", "unbewusste Programme"]
        },
        {
          name: "Konkurrenz-Bashing",
          words: ["in Programmen Geld verloren", "viel versprochen, wenig gehalten", "ich habe es satt, dass..."]
        },
        {
          name: "Testimonial-Missbrauch",
          words: ["du hast mein Leben verändert", "Kunden, die mir sagen...", "Frauen, die mir nach unserer Zusammenarbeit sagen"]
        }
      ]
    },
    {
      title: "5. SICHERE Formulierungen (🟢 Grün)",
      safe: [
        "Gibt es bei Ihnen aktuell Themen zu …?",
        "Wäre ein kurzer Austausch interessant?",
        "Interesse an einem Kennenlernen?",
        "Möchten Sie sich mal austauschen?",
        "Wollten mal unverbindlich connecten?",
        "Kurzer Austausch möglich?",
        "Falls ja, gerne antworten. Falls nein, einfach ignorieren."
      ],
      note: "Reine, neutrale Fragen ohne Leistung, Wert, Call-to-Action oder Preis."
    },
    {
      title: "6. Wie formuliere ich rechtssicher?",
      dos: [
        "Offene Fragen stellen statt Angebote machen",
        "Persönlichen Bezug herstellen (echte Recherche)",
        "Kein Zeitdruck erzeugen",
        "Keine Leistung detailliert beschreiben",
        "Einfache Antwort ermöglichen (Ja/Nein)",
        "Exit-Option bieten ('Falls nicht interessant, einfach ignorieren')"
      ],
      donts: [
        "Keine Wertangaben",
        "Keine Gratis-Angebote für Dienstleistungen",
        "Keine Termin-Links (Calendly etc.)",
        "Keine Verknappung ('nur noch X Plätze')",
        "Keine Call-to-Actions ('jetzt buchen')",
        "Keine Erfolgsversprechen",
        "Keine Heilversprechen",
        "Keine Rabatte/Sonderangebote"
      ]
    },
    {
      title: "7. Best Practice Beispiele",
      wrong: {
        subject: "Kostenloses Strategiegespräch (Wert 497 €)",
        body: `Hallo Max,

ich biete dir ein kostenloses 30-minütiges Strategiegespräch an.
Normalerweise berechne ich dafür 497 €.

Nur noch 3 Plätze frei!

Jetzt Termin buchen: [Calendly-Link]`,
        problem: "Wertangabe + Verknappung + CTA + Link = 100% Werbung"
      },
      correct: {
        subject: "Kurze Frage zu [Thema]",
        body: `Hallo Max,

ich bin Julian, beschäftige mich mit [relevantes Thema].
Mir ist aufgefallen, dass du [persönlicher Bezug].

Gibt es bei dir aktuell Themen zu [konkretes Thema]?
Wäre ein kurzer Austausch interessant?

Falls ja, gerne kurz antworten.
Falls nicht, einfach ignorieren – kein Problem.

Grüße,
Julian`,
        why: "Offene Frage + kein Angebot + kein Druck + Exit-Option"
      }
    },
    {
      title: "8. Fazit in einem Satz",
      content: "Verboten ist jede Cold-E-Mail, aus der man auch nur im Ansatz eine Verkaufsabsicht erkennt. Erlaubt ist nur: offene, neutrale Kommunikation ohne Angebot, ohne Leistung, ohne Vorteile."
    },
    {
      title: "9. Checkliste vor dem Versenden",
      checklist: [
        { question: "Enthält die E-Mail ein Gratis-Angebot?", should: false },
        { question: "Enthält die E-Mail eine Wertangabe?", should: false },
        { question: "Enthält die E-Mail einen Termin-Link?", should: false },
        { question: "Enthält die E-Mail Verknappung?", should: false },
        { question: "Enthält die E-Mail einen Call-to-Action?", should: false },
        { question: "Ist eine Verkaufsabsicht erkennbar?", should: false },
        { question: "Ist es eine offene, neutrale Frage?", should: true },
        { question: "Gibt es eine Exit-Option?", should: true }
      ],
      note: "Wenn alle ❌ beantwortet sind und beide ✅ vorhanden sind → SICHER"
    }
  ],
  footer: {
    lastUpdated: "2025",
    disclaimer: "Diese Informationen sind keine Rechtsberatung. Bei konkreten rechtlichen Fragen konsultieren Sie bitte einen Anwalt."
  }
};

